var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
import { ADD_VERSION_REQUEST, ADD_VERSION_SUCCESS, ADD_VERSION_FAILURE, GET_CHANGELOG_REQUEST, GET_CHANGELOG_SUCCESS, GET_CHANGELOG_FAILURE, GET_VERSION_DETAILS_REQUEST, GET_VERSION_DETAILS_SUCCESS, GET_VERSION_DETAILS_FAILURE, } from './constants';
var AppService = services.AppService;
export var createVersion = function (appId, version) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: ADD_VERSION_REQUEST });
                return [4 /*yield*/, AppService.createVersion(appId, version)];
            case 1:
                _a.sent();
                dispatch({ type: ADD_VERSION_SUCCESS });
                return [2 /*return*/, true];
            case 2:
                err_1 = _a.sent();
                dispatch({ type: ADD_VERSION_FAILURE });
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var loadChangeLog = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: GET_CHANGELOG_REQUEST });
                return [4 /*yield*/, AppService.loadChangeLog(appId)];
            case 1:
                response = _a.sent();
                dispatch({ type: GET_CHANGELOG_SUCCESS, logs: (response === null || response === void 0 ? void 0 : response.object) || {} });
                return [2 /*return*/, true];
            case 2:
                err_2 = _a.sent();
                dispatch({ type: GET_CHANGELOG_FAILURE });
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var fetchLatestVersionDetails = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: GET_VERSION_DETAILS_REQUEST });
                return [4 /*yield*/, AppService.fetchLatestVersionDetails(appId)];
            case 1:
                response = _a.sent();
                dispatch({
                    type: GET_VERSION_DETAILS_SUCCESS,
                    version: (response === null || response === void 0 ? void 0 : response.object) || {},
                });
                return [2 /*return*/, true];
            case 2:
                err_3 = _a.sent();
                dispatch({ type: GET_VERSION_DETAILS_FAILURE });
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
